import { atom, selector } from 'recoil';

import { intelligenceAiState } from 'components/state';

export const chatInputState = atom({
  key: 'chatInputState',
  default: null
});

export const specialtyState = atom({
  key: 'specialtyState',
  default: null
});

export const intelligenceChatIdState = atom({
  key: 'intelligenceChatIdState',
  default: null
});

export const intelligenceChatMessageIdState = atom({
  key: 'intelligenceChatMessageIdState',
  default: null
});

export const promptListState = atom({
  key: 'promptListState',
  default: []
});

export const activePromptConversationsState = atom({
  key: 'activePromptConversationsState',
  default: []
});

export const myScribeAILoadingState = atom({
  key: 'myScribeAILoadingState',
  default: false
});

export const myScribeAcknowledged = atom({
  key: 'myScribeAcknowledged',
  default: false
});

export const myScribeAutoMapSelectedNoteTypeState = atom({
  key: 'myScribeAutoMapSelectedNoteTypeState',
  default: null
});

export const myScribeAutoMapActivePromptIdState = atom({
  key: 'myScribeAutoMapActivePromptIdState',
  default: null
});

export const isAIGeneratingState = atom({
  key: 'isAIGeneratingState',
  default: false
});

export const enhanceNoteLoadingState = atom({
  key: 'enhanceNoteLoadingState',
  default: []
});

export const abortedEnhanceFormsState = atom({
  key: 'abortedEnhanceFormsState',
  default: []
});

export const pendingAbortTaskIdsState = atom({
  key: 'pendingAbortTaskIdsState',
  default: null
});

// Derived: aborting iff at least one of the task_ids snapshotted at user's
// stop click is still in flight. Auto-clears when aborted tasks drain via
// any path (abort ack, done, error) — no stuck modal on lost/mismatched
// abort acks.
export const enhanceAbortingState = selector({
  key: 'enhanceAbortingState',
  get: ({ get }) => {
    const pending = get(pendingAbortTaskIdsState);
    if (!pending?.length) return false;
    const active = get(intelligenceAiState)?.activeTaskIds ?? [];
    return pending.some((id) => active.includes(id));
  },
  set: ({ get, set }, newValue) => {
    if (newValue) {
      const active = get(intelligenceAiState)?.activeTaskIds ?? [];
      set(pendingAbortTaskIdsState, active);
    } else {
      set(pendingAbortTaskIdsState, null);
    }
  }
});

export const editedMessageIdsState = atom({
  key: 'editedMessageIdsState',
  default: new Set()
});

export const editedChatIdState = atom({
  key: 'editedChatIdState',
  default: null
});
